export const Hero404 = 'https://ik.imagekit.io/duckbill/prod/hero-404.png?updatedAt=1718093667758';
